import { i18n } from '@/plugins/i18n'
import {
  ConversionStatus,
  MediaStatus,
  MediaLevel,
  MediaType,
  MembershipRequestStatus,
  StoreStatus,
  PromotionStatus,
  TicketStatus,
  UserDeleteReason,
  UserStatus,
  StoreUserRelationStatus,
  CouponType,
  LinkType,
  CommissionAmountType,
  CommissionActionType,
  CommissionConditionID,
  CommissionOperand,
  ConversionType,
  CommissionTierType,
  CommissionMetricBase,
  TransactionStatus,
  TransactionGateway,
  TransactionType,
  UserSetupStatus,
  StoreActivePlan,
  Currency,
  UserChangeSetupStatusReason,
  StoreBusinessModel,
  StoreInfrastructure,
  AgreementType,
  AgreementStatus,
  CampaignGoal,
  CampaignPlan,
  CampaignPlanEMailType,
  CampaignPlanInstagramAdType,
  CampaignStatus,
} from '@/constants'

export const mediaStatusOption = [
    {
      value: MediaStatus.PENDING,
      label: i18n.t('media.statuses.pending'),
      style: 'w-auto text-white bg-warning'
    },
    {
      value: MediaStatus.APPROVED,
      label: i18n.t('media.statuses.approved'),
      style: 'w-auto text-white bg-success'
    },
    {
      value: MediaStatus.REJECTED,
      label: i18n.t('media.statuses.rejected'),
      style: 'w-auto text-white bg-danger'
    }
]

export const mediaStatusOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('media.status')}),
        style: ''
    },
    ...mediaStatusOption
]

export const mediaLevelOption = [
    {
        value: MediaLevel.WEAK,
        label: i18n.t('media.levels.weak')
    },
    {
        value: MediaLevel.ONE,
        label: i18n.t('media.levels.one')
    },
    {
        value: MediaLevel.TWO,
        label: i18n.t('media.levels.two')
    },
    {
        value: MediaLevel.THREE,
        label: i18n.t('media.levels.three')
    },
    {
        value: MediaLevel.FOUR,
        label: i18n.t('media.levels.four')
    },
    {
        value: MediaLevel.FIVE,
        label: i18n.t('media.levels.five')
    },
    {
        value: MediaLevel.EXCELLENT,
        label: i18n.t('media.levels.excellent')
    },
    {
        value: MediaLevel.NONE,
        label: i18n.t('media.levels.none')
    },
]

export const mediaLevelOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('media.level')}),
    },
    ...mediaLevelOption
]

export const mediaTypeOption = [
    {
        value: MediaType.WEBSITE,
        label: i18n.t('media.types.website')
    },
    {
        value: MediaType.SOCIAL_MEDIA_INSTAGRAM,
        label: i18n.t('media.types.social_media_instagram')
    },
    {
        value: MediaType.SOCIAL_MEDIA_TELEGRAM,
        label: i18n.t('media.types.social_media_telegram')
    },
    {
        value: MediaType.SOCIAL_MEDIA_FACEBOOK,
        label: i18n.t('media.types.social_media_facebook')
    },
    {
        value: MediaType.SOCIAL_MEDIA_YOUTUBE,
        label: i18n.t('media.types.social_media_youtube')
    },
    {
        value: MediaType.SOCIAL_MEDIA_TWITTER,
        label: i18n.t('media.types.social_media_twitter')
    },
    {
        value: MediaType.SOCIAL_MEDIA_OTHER,
        label: i18n.t('media.types.social_media_other')
    },
]

export const mediaTypeOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('media.type')}),
    },
    ...mediaTypeOption
]

export const userDeleteReasonOption = [
    {
        value: '',
        label: ''
    },
    {
        value: UserDeleteReason.NOT_RESPOND,
        label: i18n.t('user.delete_reason.not_respond')
    },
    {
        value: UserDeleteReason.FAKE_USER,
        label: i18n.t('user.delete_reason.fake_user')
    },
    {
        value: UserDeleteReason.TEST_ACCOUNT,
        label: i18n.t('user.delete_reason.test_account')
    }
]

export const promotionStatusOption = [
    {
        value: PromotionStatus.PENDING,
        label: i18n.t('promotion.statuses.pending'),
        style: 'mx-auto w-auto text-black-50 bg-warning'
    },
    {
        value: PromotionStatus.REJECTED,
        label: i18n.t('promotion.statuses.rejected'),
        style: 'mx-auto w-auto text-white bg-danger'
    },
    {
        value: PromotionStatus.ACTIVE,
        label: i18n.t('promotion.statuses.active'),
        style: 'mx-auto w-auto text-white bg-success'
    }
]

export const promotionStatusOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('promotion.status')}),
    },
    ...promotionStatusOption
]

export const storeStatusOption = [
    {
        value: StoreStatus.ACTIVE,
        label: i18n.t('store.statuses.active'),
        style: 'mx-auto w-auto text-white bg-success'
    },
    {
        value: StoreStatus.PAUSE,
        label: i18n.t('store.statuses.pause'),
        style: 'mx-auto w-auto text-black-50 bg-warning'
    },
    {
        value: StoreStatus.STOP,
        label: i18n.t('store.statuses.stop'),
        style: 'mx-auto w-auto text-black-50 bg-warning'
    },
    {
        value: StoreStatus.PENDING,
        label: i18n.t('store.statuses.pending'),
        style: 'mx-auto w-auto text-black-50 bg-warning'
    },
    {
        value: StoreStatus.REJECTED,
        label: i18n.t('store.statuses.rejected'),
        style: 'mx-auto w-auto text-white bg-danger'
    },
    {
        value: StoreStatus.ADD_COMMISSIONS,
        label: i18n.t('store.statuses.add_commissions'),
        style: 'mx-auto w-auto text-white bg-affili-coral'
    },
    {
        value: StoreStatus.ADD_PROMOTIONS,
        label: i18n.t('store.statuses.add_promotions'),
        style: 'mx-auto w-auto text-white bg-linkedin'
    },
    {
        value: StoreStatus.TERMINATED,
        label: i18n.t('store.statuses.terminated'),
        style: 'mx-auto w-auto text-white bg-dark'
    }
]

export const storeActivePlansOption = [
    {
        value: StoreActivePlan.NONE,
        label: i18n.t('store.active_plans.none')
    },
    {
        value: StoreActivePlan.BASE,
        label: i18n.t('store.active_plans.base')
    },
    {
        value: StoreActivePlan.BRONZE,
        label: i18n.t('store.active_plans.bronze')
    },
    {
        value: StoreActivePlan.SILVERN,
        label: i18n.t('store.active_plans.silvern')
    },
    {
        value: StoreActivePlan.GOLDEN,
        label: i18n.t('store.active_plans.golden')
    },
    {
        value: StoreActivePlan.DIAMOND,
        label: i18n.t('store.active_plans.diamond')
    },
]

export const transactionTypeOption = [
    {
        label: i18n.t('transaction.deposit'),
        value: TransactionType.DEPOSIT
    },
    {
        label: i18n.t('transaction.withdraw'),
        value: TransactionType.WITHDRAW
    },
]

export const transactionTypeOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('transaction.type')}),
    },
    ...transactionTypeOption
]

export const transactionStatusOption = [
    // We have not pending status!
    // {
    //     label: i18n.t('transaction.statuses.pending'),
    //     value: TransactionStatus.PENDING
    // },
    {
        label: i18n.t('transaction.statuses.rejected'),
        value: TransactionStatus.REJECTED
    },
    {
        label: i18n.t('transaction.statuses.approved'),
        value: TransactionStatus.APPROVED
    }
]

export const transactionStatusOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('transaction.status')}),
    },
    ...transactionStatusOption
]

export const transactionGatewayOption = [
    {
        label: i18n.t('transaction.gateways.direct'),
        value: TransactionGateway.DIRECT
    },
    {
        label: i18n.t('transaction.gateways.zarinpal'),
        value: TransactionGateway.ZARINPAL
    },
    {
        label: i18n.t('transaction.gateways.transfer'),
        value: TransactionGateway.TRANSFER
    },
    {
        label: i18n.t('transaction.gateways.bank_receipt'),
        value: TransactionGateway.BANK_RECEIPT
    }
]

export const transactionGatewayOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('transaction.gateway')}),
    },
    ...transactionGatewayOption
]

export const storeStatusOptionWithNull = [
    ...[
        {
            value: '',
            label: i18n.t('select.label_placeholder', {attribute: i18n.t('store.status')}),
            style: ''
        }
    ],
    ...storeStatusOption
]

export const ticketStatusOption = [
    {
        value: TicketStatus.ANSWERD,
        label: i18n.t('ticket.statuses.answerd'),
        style: 'w-auto text-white bg-success',
    },
    {
        value: TicketStatus.PENDING,
        label: i18n.t('ticket.statuses.pending'),
        style: 'w-auto text-white bg-warning',
    },
    {
        value: TicketStatus.CLOSED,
        label: i18n.t('ticket.statuses.closed'),
        style: 'w-auto text-white bg-secondary',
    },
    {
        value: TicketStatus.UNDER_INVESTIGATION,
        label: i18n.t('ticket.statuses.under_investigation'),
        style: 'w-auto text-white bg-affili-eggplant',
    },
    {
        value: TicketStatus.CREATED_BY_ADMIN,
        label: i18n.t('ticket.statuses.created_by_admin'),
        style: 'w-auto text-white bg-secondary',
    }
]

export const ticketStatusOptionWithNull = [
    ...[
        {
            value: '',
            label: i18n.t('select.label_placeholder', {attribute: i18n.t('ticket.status')}),
            style: ''
        }
    ],
    ...ticketStatusOption
]

export const conversionStatusOption = [
    {
        value: ConversionStatus.PENDING,
        label: i18n.t('conversion.statuses.pending')
    },
    {
        value: ConversionStatus.APPROVED,
        label: i18n.t('conversion.statuses.approved')
    },
    {
        value: ConversionStatus.REJECTED,
        label: i18n.t('conversion.statuses.rejected')
    },
    {
        value: ConversionStatus.DUPLICATED,
        label: i18n.t('conversion.statuses.duplicated')
    },
    {
        value: ConversionStatus.CHECK_REQUIRED,
        label: i18n.t('conversion.statuses.check_required')
    }
]

export const conversionEditableStatusOption = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('conversion.status')}),
    },
    {
        value: ConversionStatus.APPROVED,
        label: i18n.t('conversion.statuses.approved')
    },
    {
        value: ConversionStatus.REJECTED,
        label: i18n.t('conversion.statuses.rejected')
    },
    {
        value: ConversionStatus.CHECK_REQUIRED,
        label: i18n.t('conversion.statuses.check_required')
    }
]

export const conversionStatusOptionWithNull = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('conversion.status')})
    },
    ...conversionStatusOption
]

export const membershipRequestOption = [
    {
        value: '',
        label: ''
    },
    {
        value: i18n.t('membership_request.acquaintance_types.by_acquaintance'),
        label: i18n.t('membership_request.acquaintance_types.by_acquaintance')
    },
    {
        value: i18n.t('membership_request.acquaintance_types.google'),
        label: i18n.t('membership_request.acquaintance_types.google')
    },
    {
        value: i18n.t('membership_request.acquaintance_types.instagram'),
        label: i18n.t('membership_request.acquaintance_types.instagram')
    },
    {
        value: i18n.t('membership_request.acquaintance_types.other'),
        label: i18n.t('membership_request.acquaintance_types.other')
    },
]

export const membershipRequestStatusOption = [
    {
        value: '',
        label: ''
    },
    {
        value: MembershipRequestStatus.ACCEPTED,
        label: i18n.t('membership_request.statuses.accepted')
    },
    {
        value: MembershipRequestStatus.REJECTED,
        label: i18n.t('membership_request.statuses.rejected')
    },
]

export const userStatusOption = [
    {
        value: '',
        label: i18n.t('select.label_placeholder', {attribute: i18n.t('user.status')}),
        style: '',
    },
    {
        value: UserStatus.ACTIVE,
        label: i18n.t('user.statuses.active'),
        style: 'w-auto text-white bg-success',
    },
    {
        value: UserStatus.BLOCK,
        label: i18n.t('user.statuses.block'),
        style: 'w-auto text-white bg-danger',
    },
    {
        value: UserStatus.PENDING,
        label: i18n.t('user.statuses.pending'),
        style: 'w-auto text-white bg-warning',
    },
    {
        value: UserStatus.REMOVED,
        label: i18n.t('user.statuses.removed'),
        style: 'w-auto text-white bg-danger',
    },
    {
        value: UserStatus.REMOVED_WHEN_PENDING,
        label: i18n.t('user.statuses.removed_when_pending'),
        style: 'w-auto text-white bg-danger',
    },
]

export const storeUserRelationStatusOption = [
    {
        value: StoreUserRelationStatus.PENDING,
        label: i18n.t('store.user_rel_status.pending'),
        style: 'w-auto text-white bg-warning',
    },
    {
        value: StoreUserRelationStatus.ACTIVE,
        label: i18n.t('store.user_rel_status.active'),
        style: 'w-auto text-white bg-success',
    },
    {
        value: StoreUserRelationStatus.REJECTED,
        label: i18n.t('store.user_rel_status.rejected'),
        style: 'w-auto text-white bg-danger',
    },
    {
        value: StoreUserRelationStatus.BLOCKED,
        label: i18n.t('store.user_rel_status.blocked'),
        style: 'w-auto text-white bg-danger',
    },
    {
        value: StoreUserRelationStatus.STOP_BY_PUBLISHER,
        label: i18n.t('store.user_rel_status.stop_by_publisher'),
        style: 'w-auto text-white bg-danger',
    },
]

export const storeUserRelationStatusMerchantSideOption = [
    {
        value: StoreUserRelationStatus.ACTIVE,
        label: i18n.t('store.user_rel_status.active'),
        style: 'w-auto text-white bg-success',
    },
    {
        value: StoreUserRelationStatus.PENDING,
        label: i18n.t('store.user_rel_status.pending'),
        style: 'w-auto text-white bg-warning',
    },
    {
        value: StoreUserRelationStatus.REJECTED,
        label: i18n.t('store.user_rel_status.rejected'),
        style: 'w-auto text-white bg-danger',
    },
    {
        value: StoreUserRelationStatus.BLOCKED,
        label: i18n.t('store.user_rel_status.blocked'),
        style: 'w-auto text-white bg-danger',
    },
]

export const storeUserRelationStatusOptionWithNull = [
    ...[
        {
            value: '',
            label: i18n.t('select.label_placeholder', {attribute: i18n.t('store.user_rel_status._')}),
            style: ''
        }
    ],
    ...storeUserRelationStatusOption
]

export const couponTypeOption = [
    {
        value: '',
        label: ''
    },
    {
        value: CouponType.PERCENT,
        label: i18n.t('coupon.coupon_types.percent')
    },
    {
        value: CouponType.AMOUNT,
        label: i18n.t('coupon.coupon_types.amount')
    }
]

export const couponTypeOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...couponTypeOption
]

export const linkTypeOption = [
    {
        value: LinkType.EXCLUSIVE,
        label: i18n.t('link.types.exclusive')
    },
    {
        value: LinkType.DEVELOPER,
        label: i18n.t('link.types.developer')
    }
]

export const linkTypeOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...linkTypeOption,
]

export const commissionAmountTypeOption = [
    {
        value: CommissionAmountType.PERCENT,
        label: i18n.t('v2commission.commission_amount_types.percent')
    },
    {
        value: CommissionAmountType.AMOUNT,
        label: i18n.t('v2commission.commission_amount_types.amount')
    }
]

export const CommissionActionTypeOption = [
    {
        value: CommissionActionType.SET_PERCENTAGE,
        label: i18n.t('v2commission.action_types.set_percentage')
    },
    {
        value: CommissionActionType.SET_FLAT_AMOUNT,
        label: i18n.t('v2commission.action_types.set_flat_amount')
    },
    {
        value: CommissionActionType.MULTIPLY_BY,
        label: i18n.t('v2commission.action_types.multiply_by')
    },
    {
        value: CommissionActionType.ADD_FLAT_AMOUNT,
        label: i18n.t('v2commission.action_types.add_flat_amount')
    },
    {
        value: CommissionActionType.ADD_PERCENTAGE,
        label: i18n.t('v2commission.action_types.add_percentage')
    },
    // {
    //     value: CommissionActionType.BONUS_PERCENTAGE,
    //     label: i18n.t('v2commission.action_types.bonus_percentage')
    // },
    // {
    //     value: CommissionActionType.BONUS_FLAT_AMOUNT,
    //     label: i18n.t('v2commission.action_types.bonus_flat_amount')
    // },
]

export const CommissionActionTypeOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...CommissionActionTypeOption
]

export const CommissionPerformanceMetricsOption = [
    {
        label: i18n.t('v2commission.metrics.optgroup.sale_conversions_only'),
        options: [
            {
                value: CommissionConditionID.NUMBER_OF_SALES_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_sales_last_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_SALES_THIS_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_sales_this_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_SALES_TODAY,
                label: i18n.t('v2commission.condition.ids.number_of_sales_today'),
            },
            {
                value: CommissionConditionID.SALE_COMMISSIONS_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.sale_commissions_last_month'),
            },
            {
                value: CommissionConditionID.SALE_COMMISSIONS_THIS_MONTH,
                label: i18n.t('v2commission.condition.ids.sale_commissions_this_month'),
            },
            {
                value: CommissionConditionID.SALE_COMMISSIONS_TODAY,
                label: i18n.t('v2commission.condition.ids.sale_commissions_today'),
            },
        ]
    },
    {
        label: i18n.t('v2commission.metrics.optgroup.lead_conversions_only'),
        options: [
            {
                value: CommissionConditionID.NUMBER_OF_LEADS_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_leads_last_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_LEADS_THIS_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_leads_this_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_LEADS_TODAY,
                label: i18n.t('v2commission.condition.ids.number_of_leads_today'),
            },
            {
                value: CommissionConditionID.LEAD_COMMISSIONS_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.lead_commissions_last_month'),
            },
            {
                value: CommissionConditionID.LEAD_COMMISSIONS_THIS_MONTH,
                label: i18n.t('v2commission.condition.ids.lead_commissions_this_month'),
            },
            {
                value: CommissionConditionID.LEAD_COMMISSIONS_TODAY,
                label: i18n.t('v2commission.condition.ids.lead_commissions_today'),
            },
        ]
    },
    // {
    //     label: i18n.t('v2commission.metrics.optgroup.bonus_conversions_only'),
    //     options: [
    //         {
    //             value: CommissionConditionID.NUMBER_OF_BONUSES_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_bonuses_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_BONUSES_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_bonuses_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_BONUSES_TODAY,
    //             label: i18n.t('v2commission.condition.ids.number_of_bonuses_today'),
    //         },
    //         {
    //             value: CommissionConditionID.BONUS_COMMISSIONS_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.bonus_commissions_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.BONUS_COMMISSIONS_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.bonus_commissions_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.BONUS_COMMISSIONS_TODAY,
    //             label: i18n.t('v2commission.condition.ids.bonus_commissions_today'),
    //         },
    //     ]
    // },
    // {
    //     label: i18n.t('v2commission.metrics.optgroup.leapfrog_conversions_only'),
    //     options: [
    //         {
    //             value: CommissionConditionID.NUMBER_OF_LEAPFROGS_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_leapfrogs_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_LEAPFROGS_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_leapfrogs_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_LEAPFROGS_TODAY,
    //             label: i18n.t('v2commission.condition.ids.number_of_leapfrogs_today'),
    //         },
    //         {
    //             value: CommissionConditionID.LEAPFROG_COMMISSIONS_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.leapfrog_commissions_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.LEAPFROG_COMMISSIONS_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.leapfrog_commissions_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.LEAPFROG_COMMISSIONS_TODAY,
    //             label: i18n.t('v2commission.condition.ids.leapfrog_commissions_today'),
    //         },
    //     ]
    // },
    {
        label: i18n.t('v2commission.metrics.optgroup.combined_stats'),
        options: [
            {
                value: CommissionConditionID.COMMISSIONS_FOR_THE_CURRENT_MONTH,
                label: i18n.t('v2commission.condition.ids.commissions_for_the_current_month'),
            },
            {
                value: CommissionConditionID.COMMISSIONS_TOTAL,
                label: i18n.t('v2commission.condition.ids.commissions_total'),
            },
            {
                value: CommissionConditionID.GROSS_SALES_IN_THE_CURRENT_MONTH,
                label: i18n.t('v2commission.condition.ids.gross_sales_in_the_current_month'),
            },
            {
                value: CommissionConditionID.GROSS_SALES_TOTAL,
                label: i18n.t('v2commission.condition.ids.gross_sales_total'),
            },
            {
                value: CommissionConditionID.NET_SALES_IN_THE_CURRENT_MONTH,
                label: i18n.t('v2commission.condition.ids.net_sales_in_the_current_month'),
            },
            {
                value: CommissionConditionID.NET_SALES_TOTAL,
                label: i18n.t('v2commission.condition.ids.net_sales_total'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_SALES_IN_THE_CURRENT_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_sales_in_the_current_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_SALES_TOTAL,
                label: i18n.t('v2commission.condition.ids.number_of_sales_total'),
            },
            // {
            //     value: CommissionConditionID.HITS_IN_THE_CURRENT_MONTH,
            //     label: i18n.t('v2commission.condition.ids.hits_in_the_current_month'),
            // },
            {
                value: CommissionConditionID.SALE_AMOUNT,
                label: i18n.t('v2commission.condition.ids.sale_amount'),
            },
            {
                value: CommissionConditionID.GROSS_SALES_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.gross_sales_last_month'),
            },
            {
                value: CommissionConditionID.NET_SALES_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.net_sales_last_month'),
            },
            {
                value: CommissionConditionID.HITS_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.hits_last_month'),
            },
            {
                value: CommissionConditionID.COMMISSIONS_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.commissions_last_month'),
            },
            {
                value: CommissionConditionID.NUMBER_OF_SALES_LAST_MONTH,
                label: i18n.t('v2commission.condition.ids.number_of_sales_last_month'),
            },
        ]
    },
    // {
    //     label: i18n.t('v2commission.metrics.optgroup.sale_and_leapfrog_conversions_only'),
    //     options: [
    //         {
    //             value: CommissionConditionID.NUMBER_OF_SALES_AND_LEAPFROGS_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_sales_and_leapfrogs_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_SALES_AND_LEAPFROGS_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.number_of_sales_and_leapfrogs_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.NUMBER_OF_SALES_AND_LEAPFROGS_TODAY,
    //             label: i18n.t('v2commission.condition.ids.number_of_sales_and_leapfrogs_today'),
    //         },
    //         {
    //             value: CommissionConditionID.SALE_AND_LEAPFROG_COMMISSIONS_LAST_MONTH,
    //             label: i18n.t('v2commission.condition.ids.sale_and_leapfrog_commissions_last_month'),
    //         },
    //         {
    //             value: CommissionConditionID.SALE_AND_LEAPFROG_COMMISSIONS_THIS_MONTH,
    //             label: i18n.t('v2commission.condition.ids.sale_and_leapfrog_commissions_this_month'),
    //         },
    //         {
    //             value: CommissionConditionID.SALE_AND_LEAPFROG_COMMISSIONS_TODAY,
    //             label: i18n.t('v2commission.condition.ids.sale_and_leapfrog_commissions_today'),
    //         }
    //     ]
    // }
]

export const CommissionStrOperandOption = [
    {
        value: CommissionOperand.START_WITH,
        label: i18n.t('v2commission.operands.start_with')
    },
    {
        value: CommissionOperand.EQUAL,
        label: i18n.t('v2commission.operands.equal')
    },
    {
        value: CommissionOperand.CONTAINS,
        label: i18n.t('v2commission.operands.contains')
    },
    {
        value: CommissionOperand.END_WITH,
        label: i18n.t('v2commission.operands.end_with')
    },
    {
        value: CommissionOperand.IN_LIST,
        label: i18n.t('v2commission.operands.in_list')
    },
    {
        value: CommissionOperand.NOT_IN_LIST,
        label: i18n.t('v2commission.operands.not_in_list')
    }
]

export const CommissionStrOperandOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...CommissionStrOperandOption
]

export const CommissionIntOperandOption = [
    {
        value: CommissionOperand.GREATER_THAN,
        label: i18n.t('v2commission.operands.greater_than')
    },
    {
        value: CommissionOperand.GREATER_THAN_EQUAL,
        label: i18n.t('v2commission.operands.greater_than_equal')
    },
    {
        value: CommissionOperand.EQUAL,
        label: i18n.t('v2commission.operands.equal')
    },
    {
        value: CommissionOperand.LESS_THAN,
        label: i18n.t('v2commission.operands.less_than')
    },
    {
        value: CommissionOperand.LESS_THAN_EQUAL,
        label: i18n.t('v2commission.operands.less_than_equal')
    },
    {
        value: CommissionOperand.BETWEEN,
        label: i18n.t('v2commission.operands.between')
    }
]

export const CommissionCouponCodeAvailablityOption = [
    {
        value: 1,
        label: i18n.t('v2commission.coupon_code_availablity.available')
    },
    {
        value: 0,
        label: i18n.t('v2commission.coupon_code_availablity.not_available')
    }
]

export const CommissionCouponCodeUsageOption = [
    {
        value: 1,
        label: i18n.t('v2commission.coupon_code_usage.used')
    },
    {
        value: 0,
        label: i18n.t('v2commission.coupon_code_usage.not_used')
    }
]

export const ConversionTypeOption = [
    {
        value: ConversionType.SALE,
        label: i18n.t('conversion.types.sale')
    },
    {
        value: ConversionType.LEAD,
        label: i18n.t('conversion.types.lead')
    }
]

export const CommissionTierTypeOption = [
    {
        value: CommissionTierType.FIXED,
        label: i18n.t('v2commission.tier_types.fixed')
    },
    {
        value: CommissionTierType.MULTIPLIER,
        label: i18n.t('v2commission.tier_types.multiplier')
    }
]

export const CommissionMetricBaseOption = [
    {
        value: CommissionMetricBase.COMMISSIONS_FOR_THE_CURRENT_MONTH,
        label: i18n.t('v2commission.metric_base.commissions_for_the_current_month')
    },
    {
        value: CommissionMetricBase.COMMISSIONS_TOTAL,
        label: i18n.t('v2commission.metric_base.commissions_total')
    },
    {
        value: CommissionMetricBase.GROSS_SALES_IN_THE_CURRENT_MONTH,
        label: i18n.t('v2commission.metric_base.gross_sales_in_the_current_month')
    },
    {
        value: CommissionMetricBase.GROSS_SALES_TOTAL,
        label: i18n.t('v2commission.metric_base.gross_sales_total')
    },
    {
        value: CommissionMetricBase.NET_SALES_IN_THE_CURRENT_MONTH,
        label: i18n.t('v2commission.metric_base.net_sales_in_the_current_month')
    },
    {
        value: CommissionMetricBase.NET_SALES_TOTAL,
        label: i18n.t('v2commission.metric_base.net_sales_total')
    },
    {
        value: CommissionMetricBase.NUMBER_OF_SALES_IN_THE_CURRENT_MONTH,
        label: i18n.t('v2commission.metric_base.number_of_sales_in_the_current_month')
    },
    {
        value: CommissionMetricBase.NUMBER_OF_SALES_TOTAL,
        label: i18n.t('v2commission.metric_base.number_of_sales_total')
    },
    {
        value: CommissionMetricBase.HITS_IN_THE_CURRENT_MONTH,
        label: i18n.t('v2commission.metric_base.hits_in_the_current_month')
    },
    {
        value: CommissionMetricBase.SALE_AMOUNT,
        label: i18n.t('v2commission.metric_base.sale_amount')
    },
    {
        value: CommissionMetricBase.GROSS_SALES_LAST_MONTH,
        label: i18n.t('v2commission.metric_base.gross_sales_last_month')
    },
    {
        value: CommissionMetricBase.NET_SALES_LAST_MONTH,
        label: i18n.t('v2commission.metric_base.net_sales_last_month')
    },
    {
        value: CommissionMetricBase.HITS_LAST_MONTH,
        label: i18n.t('v2commission.metric_base.hits_last_month')
    },
    {
        value: CommissionMetricBase.COMMISSIONS_LAST_MONTH,
        label: i18n.t('v2commission.metric_base.commissions_last_month')
    },
    {
        value: CommissionMetricBase.NUMBER_OF_SALES_LAST_MONTH,
        label: i18n.t('v2commission.metric_base.number_of_sales_last_month')
    },
]

export const UserSetupStatusOption = [
    {
        value: UserSetupStatus.PERSONAL_INFO,
        label: i18n.t('user.setup_statuses.personal_info')
    },
    {
        value: UserSetupStatus.FINANCIAL_INFO,
        label: i18n.t('user.setup_statuses.financial_info')
    },
    {
        value: UserSetupStatus.MEDIA,
        label: i18n.t('user.setup_statuses.media')
    },
    {
        value: UserSetupStatus.ACTIVITY_AREA,
        label: i18n.t('user.setup_statuses.activity_area')
    },
    {
        value: UserSetupStatus.STORE_INFO,
        label: i18n.t('user.setup_statuses.store_info')
    },
    {
        value: UserSetupStatus.IMPLEMENT_SCRIPT,
        label: i18n.t('user.setup_statuses.implement_script')
    },
    {
        value: UserSetupStatus.SUBMIT_COMMISSION,
        label: i18n.t('user.setup_statuses.submit_commission')
    },
    {
        value: UserSetupStatus.CHARGE_ACCOUNT,
        label: i18n.t('user.setup_statuses.charge_account')
    },
    {
        value: UserSetupStatus.ACCEPT_AGREEMENT,
        label: i18n.t('user.setup_statuses.accept_agreement')
    },
    {
        value: UserSetupStatus.PENDING_TO_ACTIVE,
        label: i18n.t('user.setup_statuses.pending_to_active')
    },
    {
        value: UserSetupStatus.COMPLETE,
        label: i18n.t('user.setup_statuses.complete')
    },
    {
        value: UserSetupStatus.SUSPENDED,
        label: i18n.t('user.setup_statuses.suspended')
    },
]

export const UserSetupStatusOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...UserSetupStatusOption
]

export const currencyOption = [
    {
        value: Currency.IRR,
        label: i18n.t('currency.irr')
    },
    {
        value: Currency.IRT,
        label: i18n.t('currency.irt')
    },
]

export const currencyOptionWithNull = [
    {
        value: '',
        label: ''
    },
    ...currencyOption
]

export const UserChangeSetupStatusReasonOption = [
    {
        label: '',
        value: null
    },
    {
        label: i18n.t('user.change_setup_status_reason.just_for_change_setup_status_only'),
        value: UserChangeSetupStatusReason.JUST_FOR_CHANGE_SETUP_STATUS_ONLY
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_personal_info'),
        value: UserChangeSetupStatusReason.INVALID_PERSONAL_INFO
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_address'),
        value: UserChangeSetupStatusReason.INVALID_ADDRESS
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_identity_info'),
        value: UserChangeSetupStatusReason.INVALID_IDENTITY_INFO
    },
    {
        label: i18n.t('user.change_setup_status_reason.under_18_years_old'),
        value: UserChangeSetupStatusReason.UNDER_18_YEARS_OLD
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_financial_info'),
        value: UserChangeSetupStatusReason.INVALID_FINANCIAL_INFO
    },
    {
        label: i18n.t('user.change_setup_status_reason.mismatch_between_financial_and_personal_info'),
        value: UserChangeSetupStatusReason.MISMATCH_BETWEEN_FINANCIAL_AND_PERSONAL_INFO
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_store_website'),
        value: UserChangeSetupStatusReason.INVALID_STORE_WEBSITE
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_store_description'),
        value: UserChangeSetupStatusReason.INVALID_STORE_DESCRIPTION
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_store_logo'),
        value: UserChangeSetupStatusReason.INVALID_STORE_LOGO
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_script_implementation'),
        value: UserChangeSetupStatusReason.INVALID_SCRIPT_IMPLEMENTATION
    },
    {
        label: i18n.t('user.change_setup_status_reason.invalid_agreement'),
        value: UserChangeSetupStatusReason.INVALID_AGREEMENT,
    },
    {
        label: i18n.t('user.change_setup_status_reason.user_account_blocking'),
        value: UserChangeSetupStatusReason.USER_ACCOUNT_BLOCKING,
    }
]

export const StoreInfrastructureOption = [
    {
        label: i18n.t('store.infrastructures.wordpress'),
        value: StoreInfrastructure.WORDPRESS,
    },
    {
        label: i18n.t('store.infrastructures.prestashop'),
        value: StoreInfrastructure.PRESTASHOP,
    },
    {
        label: i18n.t('store.infrastructures.joomla'),
        value: StoreInfrastructure.JOOMLA,
    },
    {
        label: i18n.t('store.infrastructures.magento'),
        value: StoreInfrastructure.MAGENTO,
    },
    {
        label: i18n.t('store.infrastructures.opencart'),
        value: StoreInfrastructure.OPENCART,
    },
    {
        label: i18n.t('store.infrastructures.mixin'),
        value: StoreInfrastructure.MIXIN,
    },
    {
        label: i18n.t('store.infrastructures.portal'),
        value: StoreInfrastructure.PORTAL,
    },
    {
        label: i18n.t('store.infrastructures.shopfa'),
        value: StoreInfrastructure.SHOPFA,
    },
    {
        label: i18n.t('store.infrastructures.webzi'),
        value: StoreInfrastructure.WEBZI,
    },
    {
        label: i18n.t('store.infrastructures.other'),
        value: StoreInfrastructure.OTHER,
    },
]

export const StoreBusinessModelOption = [
    {
        label: i18n.t('store.business_models.e_commerce'),
        value: StoreBusinessModel.E_COMMERCE,
    },
    {
        label: i18n.t('store.business_models.software_as_a_service'),
        value: StoreBusinessModel.SOFTWARE_AS_A_SERVICE,
    },
    {
        label: i18n.t('store.business_models.subscription'),
        value: StoreBusinessModel.SUBSCRIPTION,
    },
]


export const AgreementTypeOption = [
    {
        label: i18n.t('agreement.types.real'),
        value: AgreementType.REAL,
    },
    {
        label: i18n.t('agreement.types.legal'),
        value: AgreementType.LEGAL,
    },
]

export const AgreementTypeOptionWithNull = [
    {
        label: '',
        value: ''
    },
    ...AgreementTypeOption,
]

export const AgreementStatusOption = [
    {
        label: i18n.t('agreement.statuses.pending'),
        value: AgreementStatus.PENDING,
    },
    {
        label: i18n.t('agreement.statuses.rejected'),
        value: AgreementStatus.REJECTED,
    },
    {
        label: i18n.t('agreement.statuses.approved'),
        value: AgreementStatus.APPROVED,
    },
]

export const AgreementStatusOptionWithNull = [
    {
        label: '',
        value: ''
    },
    ...AgreementStatusOption,
]

export const campaignPlanOption = [
    {
        label: i18n.t('campaign.plans.in_app._'),
        value: CampaignPlan.IN_APP,
        icon: 'window-maximize',
        settings: {
            max_send: 500,
            content: '',
            tags: [],
        },
        goals: [
            CampaignGoal.GET_NEW_PUBLISHERS,
            CampaignGoal.ACTIVE_OLD_PUBLISHERS,
            CampaignGoal.INCREASE_SALE,
            CampaignGoal.INCREASE_LEAD,
            CampaignGoal.NOTIFICATION,
        ],
        cost: {
            unit: 1,
            price: 2500, //250 IRT
        }
    },
    {
        label: i18n.t('campaign.plans.email._'),
        value: CampaignPlan.EMAIL,
        icon: 'envelope',
        settings: {
            email_type: CampaignPlanEMailType.EXCLUSIVE,
            max_send: 500,
            content: '',
            tags: [],
        },
        goals: [
            CampaignGoal.GET_NEW_PUBLISHERS,
            CampaignGoal.ACTIVE_OLD_PUBLISHERS,
            CampaignGoal.INCREASE_SALE,
            CampaignGoal.INCREASE_LEAD,
            CampaignGoal.NOTIFICATION,
        ],
        cost: {
            unit: 1,
            price: 2000, //200 IRT
            coefficient: {
                key: 'email_type',
                vals: {
                    [CampaignPlanEMailType.EXCLUSIVE]: 3,
                    [CampaignPlanEMailType.WEEKLY_NEWSLETTER]: 2,
                    [CampaignPlanEMailType.MONTHLY_NEWSLETTER]: 1,
                }
            }
        }
    },
    {
        label: i18n.t('campaign.plans.sms._'),
        value: CampaignPlan.SMS,
        icon: 'comment-sms',
        settings: {
            max_send: 500,
            content: '',
            tags: [],
        },
        goals: [
            CampaignGoal.GET_NEW_PUBLISHERS,
            CampaignGoal.ACTIVE_OLD_PUBLISHERS,
            CampaignGoal.INCREASE_SALE,
            CampaignGoal.INCREASE_LEAD,
            CampaignGoal.NOTIFICATION,
        ],
        cost: {
            unit: 1,
            price: 5000, //500 IRT
        }
    },
    // {
    //     label: i18n.t('campaign.plans.blog_post._'),
    //     value: CampaignPlan.BLOG_POST,
    //     icon: ['fab', 'blogger-b'],
    //     settings: {
    //         target_clicks: 500,
    //         content: ''
    //     },
    //     goals: [
    //         CampaignGoal.GET_NEW_PUBLISHERS,
    //     ],
    //     cost: {
    //         unit: 1,
    //         price: 4000 //400 IRT
    //     }
    // },
    // {
    //     label: i18n.t('campaign.plans.reportage._'),
    //     value: CampaignPlan.REPORTAGE,
    //     icon: 'newspaper',
    //     settings: {
    //         content: ''
    //     },
    //     goals: [
    //         CampaignGoal.GET_NEW_PUBLISHERS,
    //     ],
    //     cost: {
    //         unit: 1,
    //         price: 15000000 //1,500,000 IRT
    //     }
    // },
    // {
    //     label: i18n.t('campaign.plans.retarget._'),
    //     value: CampaignPlan.RETARGET,
    //     icon: ['far', 'circle-dot'],
    //     settings: {
    //         period_unit: 'month',
    //         period: 1,
    //         native_ads: [],
    //         // banner_ads: [], // TODO: support later
    //     },
    //     goals: [
    //         CampaignGoal.GET_NEW_PUBLISHERS,
    //         CampaignGoal.ACTIVE_OLD_PUBLISHERS,
    //     ],
    //     cost: {
    //         unit: 1,
    //         price: 2500000, //250,000 IRT
    //         coefficient: {
    //             key: 'period_unit',
    //             vals: {
    //                 'week': 1,
    //                 'month': 4,
    //             }
    //         },
    //     }
    // },
    {
        label: i18n.t('campaign.plans.top_store._'),
        value: CampaignPlan.TOP_STORE,
        icon: 'medal',
        settings: {
            period_unit: 'week',
            period: 1
        },
        goals: [
            CampaignGoal.GET_NEW_PUBLISHERS,
        ],
        cost: {
            unit: 1,
            price: 1000000, //100,000 IRT
            coefficient: {
                key: 'period_unit',
                vals: {
                    'week': 1,
                    'month': 4,
                }
            },
        }
    },
    {
        label: i18n.t('campaign.plans.store_of_the_week._'),
        value: CampaignPlan.STORE_OF_THE_WEEK,
        icon: 'star',
        settings: {
            period_unit: 'week',
            period: 1
        },
        goals: [
            CampaignGoal.GET_NEW_PUBLISHERS,
        ],
        cost: {
            unit: 1,
            price: 1000000, //100,000 IRT
            coefficient: {
                key: 'period_unit',
                vals: {
                    'week': 1,
                    'month': 4,
                }
            },
        }
    },
    // {
    //     label: i18n.t('campaign.plans.affili_telegram_channel._'),
    //     value: CampaignPlan.AFFILI_TELEGRAM_CHANNEL,
    //     icon: ['fab', 'telegram'],
    //     settings: {
    //         content: '',
    //     },
    //     goals: [
    //         CampaignGoal.GET_NEW_PUBLISHERS,
    //         CampaignGoal.ACTIVE_OLD_PUBLISHERS,
    //         CampaignGoal.INCREASE_SALE,
    //         CampaignGoal.INCREASE_LEAD,
    //     ],
    //     cost: {
    //         unit: 1,
    //         price: 500000 //50,000 IRT
    //     }
    // },
    // {
    //     label: i18n.t('campaign.plans.affili_instagram_page._'),
    //     value: CampaignPlan.AFFILI_INSTAGRAM_PAGE,
    //     icon: ['fab', 'instagram'],
    //     settings: {
    //         instagram_ad_type: CampaignPlanInstagramAdType.STORY,
    //         content: '',
    //     },
    //     goals: [
    //         CampaignGoal.GET_NEW_PUBLISHERS,
    //         CampaignGoal.ACTIVE_OLD_PUBLISHERS,
    //         CampaignGoal.INCREASE_SALE,
    //         CampaignGoal.INCREASE_LEAD,
    //     ],
    //     cost: {
    //         unit: 1,
    //         price: 1500000, //150,000 IRT
    //         coefficient: {
    //             key: 'instagram_ad_type',
    //             vals: {
    //                 [CampaignPlanInstagramAdType.STORY]: 1,
    //                 [CampaignPlanInstagramAdType.POST]: 4,
    //             }
    //         },
    //     }
    // },
]

export const campaignPlanOptionWithNull = [
    {
        label: i18n.t('campaign.plan'),
        value: '',
    },
    ...campaignPlanOption.filter(option => {
        return {
            label: option.label,
            value: option.value,
        }
    }),
]

export const campaignGoalOption = [
    {
        label: i18n.t('campaign.goals.get_new_publishers._'),
        value: CampaignGoal.GET_NEW_PUBLISHERS,
        description: i18n.t('campaign.goals.get_new_publishers.description'),
        icon: 'face-smile',
    },
    {
        label: i18n.t('campaign.goals.active_old_publishers._'),
        value: CampaignGoal.ACTIVE_OLD_PUBLISHERS,
        description: i18n.t('campaign.goals.active_old_publishers.description'),
        icon: 'arrow-trend-up',
    },
    {
        label: i18n.t('campaign.goals.increase_sale._'),
        value: CampaignGoal.INCREASE_SALE,
        description: i18n.t('campaign.goals.increase_sale.description'),
        icon: 'coins',
    },
    {
        label: i18n.t('campaign.goals.increase_lead._'),
        value: CampaignGoal.INCREASE_LEAD,
        description: i18n.t('campaign.goals.increase_lead.description'),
        icon: ['brands', 'wpforms'],
    },
    {
        label: i18n.t('campaign.goals.notification._'),
        value: CampaignGoal.NOTIFICATION,
        description: i18n.t('campaign.goals.notification.description'),
        icon: 'bullhorn',
    },
]

export const campaignGoalOptionWithNull = [
    {
        label: i18n.t('campaign.goal'),
        value: '',
    },
    ...campaignGoalOption.filter(option => {
        return {
            label: option.label,
            value: option.value,
        }
    }),
]

export const campaignPlanEmailTypeOption = [
    {
        label: i18n.t('campaign.settings.email_types.exclusive._'),
        value: CampaignPlanEMailType.EXCLUSIVE,
        description: i18n.t('campaign.settings.email_types.exclusive.description'),
    },
    {
        label: i18n.t('campaign.settings.email_types.weekly_newsletter._'),
        value: CampaignPlanEMailType.WEEKLY_NEWSLETTER,
        description: i18n.t('campaign.settings.email_types.weekly_newsletter.description'),
    },
    {
        label: i18n.t('campaign.settings.email_types.monthly_newsletter._'),
        value: CampaignPlanEMailType.MONTHLY_NEWSLETTER,
        description: i18n.t('campaign.settings.email_types.monthly_newsletter.description'),
    },
]


export const campaignPlanInstagramAdTypeOption = [
    {
        label: i18n.t('campaign.settings.instagram_ad_types.story._'),
        value: CampaignPlanInstagramAdType.STORY,
        description: i18n.t('campaign.settings.instagram_ad_types.story.description'),
    },
    {
        label: i18n.t('campaign.settings.instagram_ad_types.post._'),
        value: CampaignPlanInstagramAdType.POST,
        description: i18n.t('campaign.settings.instagram_ad_types.post.description'),
    },
]

export const campaignStatusOption = [
    {
        label: i18n.t('campaign.statuses.pending'),
        value: CampaignStatus.PENDING,
        style: 'mx-auto w-auto text-black-50 bg-warning',
    },
    {
        label: i18n.t('campaign.statuses.approved'),
        value: CampaignStatus.APPROVED,
        style: 'mx-auto w-auto text-white bg-primary',
    },
    {
        label: i18n.t('campaign.statuses.running'),
        value: CampaignStatus.RUNNING,
        style: 'mx-auto w-auto text-white bg-info',
    },
    {
        label: i18n.t('campaign.statuses.stopped'),
        value: CampaignStatus.STOPPED,
        style: 'mx-auto w-auto text-black-50 bg-secondary',
    },
    {
        label: i18n.t('campaign.statuses.cancelled'),
        value: CampaignStatus.CANCELLED,
        style: 'mx-auto w-auto text-white bg-danger',
    },
    {
        label: i18n.t('campaign.statuses.finished'),
        value: CampaignStatus.FINISHED,
        style: 'mx-auto w-auto text-white bg-success',
    },
]
